export * from './config';
export * from './dataLayer';
export * from './pagetracking';
export * from './eventTracking';
import { initializeDigitalData, setUserInfo, setSiteInfo } from './dataLayer';

/**
 * Adobe Analytics digitalData Object Types
 */

export interface PageInfo {
    page: string;
    pageNameGranular: string;
    pageName: string;
    pageTemplate?: string;
    pageType?: string;
    previousPage?: string;
    previousLink?: string;
    [key: string]: any;
  }
  
  export interface PageContent {
    title?: string;
    type?: string;
    author?: string;
    source?: string;
    contentID?: string;
    contentView?: string;
    owner?: string;
    contentPublishDate?: string;
    contentModificationDate?: string;
    contentTags?: string;
    contentTopic?: string;
    contentDaysSincePublish?: string | number;
    [key: string]: any;
  }
  
  export interface Page {
    pageInfo?: PageInfo;
    content?: PageContent;
    module?: {
      position?: string;
      category?: string;
      name?: string;
    };
    category?: Record<string, any>;
    section?: {
      sectionName?: string;
      subSection1?: string;
      subSection2?: string;
      subSection3?: string;
    };
    breadcrumb?: string;
    hierarchy?: string;
    [key: string]: any;
  }
  
  export interface UserProfile {
    age?: string;
    gender?: string;
    postal?: string;
    region?: string;
    entity?: string;
    registerstatus?: string;
    [key: string]: any;
  }
  
  export interface UserJob {
    jobFunction?: string;
    department?: string;
    jobRole?: string;
    jobLevel?: string;
    [key: string]: any;
  }
  
  export interface UserEmployee {
    union?: string;
    workforceClass?: string;
    employeeTenure?: string;
    employeeBase?: string;
    employeeBase_perRegion?: string;
    [key: string]: any;
  }
  
  export interface User {
    userID?: string;
    profile?: UserProfile;
    job?: UserJob;
    employee?: UserEmployee;
    loginState?: 'Authenticated' | 'Unauthenticated';
    userType?: string;
    timestamp?: string;
    userKnown?: boolean;
    [key: string]: any;
  }
  
  export interface Site {
    siteName?: string;
    domain?: string;
    subdomain?: string;
    language?: string;
    charSet?: string;
    applicationName?: 'citizenship' | 'tuition';
    [key: string]: any;
  }
  
  export interface Event {
    actionName?: string;
    linkClick?: {
      linkName?: string;
      linkLocation?: string;
      linkURL?: string;
      shareType?: string;
      social_network?: string;
    };
    buttonClick?: {
      buttonName?: string;
      buttonLocation?: string;
      buttonURL?: string;
      clickType?: string;
    };
    [key: string]: any;
  }
  
  export interface DigitalData {
    page?: Page;
    user?: User;
    site?: Site;
    event?: Event;
    [key: string]: any;
  }
  
  /**
   * Extend Window interface to include digitalData
   */
  declare global {
    interface Window {
      digitalData?: DigitalData;
      _satellite?: {
        track: (eventName: string) => void;
        [key: string]: any;
      };
    }
  }

/**
 * Initialize analytics on app load
 */
export const initializeAnalytics = (userData: {
  nuid?: string;
  email?: string;
  region?: string;
  userType?: string;
}): void => {
  console.log('🚀 Initializing Analytics...');
  
  
  // Initialize data layer
  initializeDigitalData();
  
  // Set user info from Redux or auth
  setUserInfo({
    ...userData,
    loginState: userData.nuid ? 'Authenticated' : 'Unauthenticated',
  });
  
  // Set site info (determine app from URL)
  const app = globalThis.location.pathname.includes('/tuition') ? 'tuition' : 'citizenship';
  setSiteInfo(app);
  
  console.log('✅ Analytics Initialized');
};